import React, { Component } from 'react';

import './App.css';

import Discover from './components/Discover'

class App extends Component {
  componentDidMount () {
    document.title = "Download de McDonald's app"
  }
  render() {
    return (
      <div className="App">
        <Discover />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js